import React, { useState } from 'react';

const UserAvatar = ({ 
  src, 
  alt = "User avatar", 
  width = 30, 
  height = 30, 
  className = "", 
  style = {},
  fallbackSrc = null,
  isKjuup = false
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  // Determine the final image source
  const getImageSrc = () => {
    if (imageError || !src) {
      return fallbackSrc || process.env.PUBLIC_URL + "/assets/img/head.svg";
    }
    return src;
  };

  const imageSrc = getImageSrc();
  const isFallback = !src || imageSrc?.includes('head.svg') || imageError;
  
  // Note: outline is applied AFTER style spread to ensure isKjuup outline takes precedence
  // Using outline with outlineOffset to create a 1px gap between avatar and green ring
  const defaultStyle = {
    borderRadius: "100px",
    objectFit: "cover",
    opacity: imageLoaded || isFallback ? 1 : 0,
    transition: "opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
    ...style,
    ...(isKjuup ? { 
      outline: "2px solid var(--kjuup-internal)",
      outlineOffset: "2px"
    } : {})
  };

  return (
    <img
      width={width}
      height={height}
      className={className}
      style={defaultStyle}
      src={imageSrc}
      alt={alt}
      onError={handleImageError}
      onLoad={handleImageLoad}
    />
  );
};

export default UserAvatar;
